import gql from "graphql-tag";

export const CREATE_PERSON_MUTATION = gql`
  mutation createPerson(
    $relation: RelationEnum!
    $personInputDetails: PersonInput!
  ) {
    createPerson(relation: $relation, personInput: $personInputDetails) {
      id
      testatorId
      firstNames
      lastName
      fullName
      email
      contactNumber
      phoneCountryCode
      contactNumber2
      phoneCountryCode2
      kinship
      dateOfBirth
      gender
      displayName
      educatable
      referralInviteSent
      referralInviteSentTime
      insuranceChildValidation {
        personId
        evaluation
      }
      identityNumber {
        id
        idType
        number
        countryCode
      }
      testatorRelationships {
        id
        relation
        createdAt
      }
      distributionSpecificPercentage {
        id
      }
      distributionSpecificPercentageAlternatives {
        id
      }
      alternativeDistributionSpecificPercentage {
        id
      }
      specificDonations {
        id
      }
      distributionSpecificPercentageAlternativeBeneficiaries {
        id
      }
    }
  }
`;

export const UPDATE_PERSON_MUTATION = gql`
  mutation updatePerson($id: ID!, $personInputDetails: PersonInput!) {
    updatePerson(id: $id, personInput: $personInputDetails) {
      id
      testatorId
      firstNames
      lastName
      fullName
      email
      contactNumber
      phoneCountryCode
      contactNumber2
      phoneCountryCode2
      kinship
      dateOfBirth
      gender
      displayName
      referralInviteSent
      referralInviteSentTime
      identityNumber {
        id
        idType
        number
        countryCode
      }
      testatorRelationships {
        id
        relation
        createdAt
      }
      distributionSpecificPercentage {
        id
      }
      distributionSpecificPercentageAlternatives {
        id
      }
      alternativeDistributionSpecificPercentage {
        id
      }
      specificDonations {
        id
      }
      distributionSpecificPercentageAlternativeBeneficiaries {
        id
      }
    }
  }
`;

export const CREATE_TESTATOR_RELATIONSHIP_MUTATION = gql`
  mutation createTestatorRelationship(
    $testatorRelationshipInputDetails: TestatorRelationshipInput!
  ) {
    createTestatorRelationship(
      testatorRelationshipInput: $testatorRelationshipInputDetails
    ) {
      id
      testatorId
      personId
      relation
      createdAt
    }
  }
`;

export const DELETE_TESTATOR_RELATIONSHIP_MUTATION = gql`
  mutation deleteTestatorRelationship($id: ID!) {
    deleteTestatorRelationship(id: $id) {
      testatorRelationshipId
      personId
      specificDonations
    }
  }
`;

export const REFER_A_FRIEND_QUERY = gql`
  query Testator($id: ID!) {
    testator(id: $id) {
      id
      willCountry
      people {
        fullName
        email
      }
      company {
        id
        referAFriend
      }
    }
  }
`;
